/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "flowStepLinkDefs",
    graphQL: "FlowStepLinkDef",
    name: "Flow Step Link Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowStepLinkDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Step Link Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flowStepDef) => {
                return flowStepDef['flowDef_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        flowStepDef: {
            name: "Flow Step Definition",
            to: () => types['flowStepDefs'],
            type: "relation",
            defaultValue: (flowStepDef) => {
                return flowStepDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDef", "flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        to: {
            name: "Flow Step Definition",
            to: () => types['flowStepDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow ? flow['id'] : undefined;
            },
            required: true,
            relativeTo: ["flowDef"],
        },
        key: {
            name: "Key",
            type: "string",
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
        },
        options: {
            name: "Options",
            type: "object",
            defaultValue: {},
        },
        runOnError: {
            name: "Run on error",
            type: "boolean",
            defaultValue: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
});
